import styled from "styled-components";
import { MarginBottom8, MarginRight20, MarginBottom20, MarginTop20 } from "../../components/margins";
import { TitleMainStyle, Title as BaseTitle } from "../../components/titles";
import { ButtonGradient } from "../../components/Buttons";
import { TextBlock, TextAlignCenter } from "../../components/text";
import { FontSize22, FontFamilyMedium, FontSize14 } from "../../components/fonts";
import { THEME_COLORS } from "../../styles/theme";

export const Title = styled(BaseTitle)`
    ${TextAlignCenter};
`;

export const TitleAlreadyClient = styled.h2`
    ${TitleMainStyle};
    ${MarginBottom8};
    ${TextAlignCenter};
`;

export const ButtonsContainer = styled.div`
    display: flex;
    justify-content: 'center';
`;

export const ButtonWrapper = styled.div`
    width: 100%;
    max-width: 180px;
`;

export const ButtonWrapperRightMargin = styled(ButtonWrapper)`
    ${MarginRight20};
`;

export const CallMeBackButtonMobile = styled(ButtonGradient)`
    width: auto;
    height: 42px;
`;

export const Card = styled.div`
    width: 100%;
    max-width: 380px;
    position: relative;
    border-radius: 35px;
    box-shadow: 0 10px 35px 0 rgba(81, 129, 186, 0.25);
    padding: ${props => props.hasBottomButton ? '30px 35px 50px 35px' : '30px 35px 35px 35px'};
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
`;

export const CardButtonAbsoluteContainer = styled.div`
  position: absolute;
  bottom: -20px;
  width: 100%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
`;

export const CardTitle = styled(TextBlock)`
    ${FontFamilyMedium};
    ${FontSize22};
    ${MarginBottom20};
    ${TextAlignCenter};
    font-weight: 500;
    color: ${props => props.theme.color[THEME_COLORS.darkBlue]};
`;

export const CardText = styled(TextBlock)`
    ${FontSize14};
    ${TextAlignCenter};
    width: 100%;
`;

export const CallMeBackButtonWrapper = styled.div`
    width: 100%;
    max-width: 200px;
`;

export const CardSpaceTopWrapper = styled.div`
    ${MarginTop20};
    width: 100%;
    display: flex;
    justify-content: center;
`;